export const APP_ACTIONS = {
  SET_CURRENT_HOME_SECTION: "SET_CURRENT_HOME_SECTION",
};
